import { get, post, del, put } from "../libs/https";
const publicPath = process.env.BASE_URL;

export const getApplicationChecklist = async (appGUID, type) => {
    return await get(`${publicPath}api/checklist/${appGUID}?type=${type}`);
};

export const addApplicationChecklistItem = async (appGUID, item, type) => {
    return await post(`${publicPath}api/checklist/${appGUID}?type=${type}`, item);
};

export const updateApplicationChecklistItem = async (appGUID, item, type) => {
    return await put(`${publicPath}api/checklist/${appGUID}?type=${type}`, item);
};

export const removeApplicationChecklistItem = async (appGUID, item, type) => {
    return await del(`${publicPath}api/checklist/${appGUID}?type=${type}`, item);
};